var angular = require('angular');
var _module = angular.module('listreports.core', []);


module.exports = _module;